(function () {
  if (typeof window !== 'undefined' && window.BgRecs) return;

  var UK_VENDORS = ['Panache', 'Wacoal', 'Curvy Kate - Scantilly', 'Elila', 'Cake Lingerie', 'Hotmilk', 'Concept Brands'];
  var NON_UK_VENDORS = [
    'Triumph International',
    'Hanes - Berlei Bonds Jockey Hosier',
    'Nala',
    'P Labs',
    'Simon de Winter',
    'Glamorise',
    'Bendon Fayreform',
    'Leading Lady',
    'Amoena',
    'Exquisite Form',
    'Lady Emprezz',
    'Capriosca',
    "Big Girls Don't Cry (Anymore)"
  ];
  var CUPS = ['AA', 'A', 'B', 'C', 'D', 'DD', 'DDD', 'E', 'F', 'FF', 'G', 'GG', 'H', 'HH', 'J', 'JJ', 'K', 'KK', 'L', 'LL'];
  var UK_SEQ = ['AA', 'A', 'B', 'C', 'D', 'DD', 'E', 'F', 'FF', 'G', 'GG', 'H', 'HH', 'J', 'JJ', 'K', 'KK', 'L', 'LL'];
  var NON_UK_SEQ = ['AA', 'A', 'B', 'C', 'D', 'DD', 'E', 'F', 'G', 'H', 'J', 'K', 'L'];
  var LETTERS = ['XS', 'S', 'M', 'L', 'XL', '1XL', '2XL', '3XL', '4XL', '5XL', '6XL'];
  var LETTER_ALIASES = {
    'X-SMALL': 'XS',
    XSMALL: 'XS',
    SMALL: 'S',
    MEDIUM: 'M',
    LARGE: 'L',
    'X-LARGE': 'XL',
    XLARGE: 'XL',
    'EXTRA LARGE': 'XL',
    XXL: '2XL',
    XXXL: '3XL',
    XXXXL: '4XL'
  };
  var LETTER_RE = '(XS|S|M|L|XL|XXL|XXXL|[1-6]XL)';
  // Same rule as theme.rememberedSize (BG #83): the "sizes" cookie only counts when it holds one plain band + cup size
  var BAND_CUP = /^\d{1,2}(A|B|C|D|DD|E|F|FF|G|GG|H|HH|J|JJ|K|KK|L|LL)$/;

  function clean(raw) {
    return String(raw == null ? '' : raw)
      .replace(/ /g, ' ')
      .replace(/\s+/g, ' ')
      .trim()
      .toUpperCase()
      .replace(/^[A-Z][A-Z ]{2,} ?-\s*(?=\d)/, '');
  }

  function letter(value) {
    if (LETTER_ALIASES[value]) return LETTER_ALIASES[value];
    return LETTERS.indexOf(value) >= 0 ? value : null;
  }

  function numeric(value) {
    if (!/^[1-9]\d?$/.test(value)) return null;
    var n = parseInt(value, 10);
    return n >= 4 && n <= 30 ? String(n) : null;
  }

  function canonCup(cup) {
    return cup === 'DDD' ? 'E' : cup;
  }

  function cupTokens(text) {
    if (/[\/-]/.test(text)) {
      var parts = text.split(/[\/-]/).map(function (t) {
        return t.replace(/^\d+/, '');
      }).filter(Boolean);
      for (var i = 0; i < parts.length; i++) {
        if (CUPS.indexOf(parts[i]) < 0) return null;
      }
      return parts.length ? parts : null;
    }
    if (CUPS.indexOf(text) >= 0) return [text];
    var best = null;
    (function walk(pos, prev, acc) {
      if (pos === text.length) {
        if (!best || acc.length > best.length) best = acc.slice();
        return;
      }
      for (var len = 3; len >= 1; len--) {
        var token = text.substr(pos, len);
        var idx = CUPS.indexOf(token);
        if (token.length === len && idx > prev) {
          acc.push(token);
          walk(pos + len, idx, acc);
          acc.pop();
        }
      }
    })(0, -1, []);
    return best;
  }

  function expandCups(tokens) {
    if (tokens.length === 1) return [canonCup(tokens[0])];
    var from = CUPS.indexOf(tokens[0]);
    var to = CUPS.indexOf(tokens[tokens.length - 1]);
    var out = [];
    for (var i = from; i <= to; i++) {
      var cup = canonCup(CUPS[i]);
      if (out.indexOf(cup) < 0) out.push(cup);
    }
    return out;
  }

  function parseSize(raw) {
    var s = clean(raw);
    var none = { items: [], exact: false };
    if (!s || /^(ONE SIZE|1 SIZE|DEFAULT TITLE)/.test(s)) return none;
    var m;

    m = s.match(new RegExp('^' + LETTER_RE + ' ?\\(AU ?(\\d{1,2})\\)$'));
    if (m && letter(m[1]) && numeric(m[2])) {
      return { items: [{ f: 'letter', v: letter(m[1]) }, { f: 'num', v: numeric(m[2]) }], exact: true };
    }

    m = s.match(new RegExp('^(\\d{1,2}) ?\\/ ?' + LETTER_RE + '$'));
    if (m && letter(m[2]) && numeric(m[1])) {
      return { items: [{ f: 'num', v: numeric(m[1]) }, { f: 'letter', v: letter(m[2]) }], exact: true };
    }

    m = s.match(new RegExp('^' + LETTER_RE + ' ?[-\\/] ?' + LETTER_RE + '$'));
    if (m && letter(m[1]) && letter(m[2])) {
      return { items: [{ f: 'letter', v: letter(m[1]) }, { f: 'letter', v: letter(m[2]) }], exact: false };
    }

    m = s.match(new RegExp('^' + LETTER_RE + '[- ]([A-L][A-L\\/-]*)$'));
    if (m && letter(m[1]) && cupTokens(m[2])) {
      return { items: [{ f: 'letter', v: letter(m[1]) }], exact: false };
    }

    var single = letter(s);
    if (single) return { items: [{ f: 'letter', v: single }], exact: true };

    var num = numeric(s);
    if (num) return { items: [{ f: 'num', v: num }], exact: true };

    m = s.match(/^(\d{1,2}) ?[-\/] ?(\d{1,2})$/);
    if (m && numeric(m[1]) && numeric(m[2]) && +m[1] < +m[2]) {
      var nums = [];
      for (var n = +m[1]; n <= +m[2]; n += 2) nums.push({ f: 'num', v: String(n) });
      return { items: nums, exact: false };
    }

    m = s.replace(/ /g, '').match(/^(\d{1,2})-?([A-L][A-L0-9\/-]*)$/);
    if (m && +m[1] >= 4) {
      var tokens = cupTokens(m[2]);
      if (tokens) {
        var cups = expandCups(tokens);
        return {
          items: cups.map(function (cup) {
            return { f: 'bra', v: String(+m[1]) + cup };
          }),
          exact: tokens.length === 1
        };
      }
    }

    return none;
  }

  function brandSeq(product) {
    if (UK_VENDORS.indexOf(product.v) >= 0) return UK_SEQ;
    if (NON_UK_VENDORS.indexOf(product.v) >= 0) return NON_UK_SEQ;
    var cups = {};
    (product.a || []).forEach(function (raw) {
      clean(raw).replace(/ /g, '').replace(/^\d{1,2}-?/, '').split(/[\/-]/).forEach(function (part) {
        cups[part] = true;
      });
    });
    if (cups.FF || cups.GG || cups.HH || cups.JJ || cups.KK) return UK_SEQ;
    if (cups.G) return NON_UK_SEQ;
    return null;
  }

  function sistersOf(size, seq) {
    var m = size.match(/^(\d{1,2})([A-Z]+)$/);
    if (!m) return [];
    var band = +m[1];
    var i = seq.indexOf(m[2]);
    if (i < 0) return [];
    var out = [];
    if (i + 1 < seq.length && band - 2 >= 4) out.push(band - 2 + seq[i + 1]);
    if (i - 1 >= 0) out.push(band + 2 + seq[i - 1]);
    return out;
  }

  function itemsOf(list) {
    var out = [];
    (list || []).forEach(function (raw) {
      out = out.concat(parseSize(raw).items);
    });
    return out;
  }

  function classify(product, sizes) {
    var families = {};
    itemsOf(product.a).forEach(function (it) {
      families[it.f] = true;
    });
    var relevant = Object.keys(families).filter(function (f) {
      return sizes[f] && sizes[f].length;
    });
    if (!relevant.length) return 'any';
    var available = itemsOf(product.s);
    var exact = available.some(function (it) {
      return relevant.indexOf(it.f) >= 0 && sizes[it.f].indexOf(it.v) >= 0;
    });
    if (exact) return 'exact';
    if (relevant.indexOf('bra') >= 0) {
      var seq = brandSeq(product);
      if (seq) {
        var sisters = [];
        sizes.bra.forEach(function (size) {
          sisters = sisters.concat(sistersOf(size, seq));
        });
        var sister = available.some(function (it) {
          return it.f === 'bra' && sisters.indexOf(it.v) >= 0;
        });
        if (sister) return 'sister';
      }
    }
    return null;
  }

  // Reads the size BG already remembers (the "sizes" cookie, written by theme.js). Never writes it.
  function sizeFromCookie(cookieString) {
    var match = ('; ' + (cookieString || '')).match(/; ?sizes=([^;]*)/);
    if (!match) return null;
    var value;
    try {
      value = decodeURIComponent(match[1]);
      value = JSON.parse(value);
    } catch (e) {}
    value = String(value == null ? '' : value).trim().toUpperCase();
    return BAND_CUP.test(value) ? value : null;
  }

  var api = {
    parseSize: parseSize,
    classify: classify,
    sistersOf: sistersOf,
    brandSeq: brandSeq,
    sizeFromCookie: sizeFromCookie,
    UK_SEQ: UK_SEQ,
    NON_UK_SEQ: NON_UK_SEQ
  };

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = api;
    return;
  }
  window.BgRecs = api;

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var ALL_SIZES_KEY = 'bg-recs-all-sizes';
  var HISTORY_KEY = 'theme-recent';
  var IDS_KEY = 'bg-recs-ids';
  var MIN_PRODUCTS = 4;
  var FAMILIES = ['bra', 'letter', 'num'];

  function readJSON(storage, key, fallback) {
    try {
      var value = storage.getItem(key);
      return value ? JSON.parse(value) : fallback;
    } catch (e) {
      return fallback;
    }
  }

  function writeJSON(storage, key, value) {
    try {
      storage.setItem(key, JSON.stringify(value));
    } catch (e) {}
  }

  function currentSizes() {
    var sizes = { bra: [], letter: [], num: [] };
    if (readJSON(sessionStorage, ALL_SIZES_KEY, false)) return sizes;
    var size = sizeFromCookie(document.cookie);
    if (size) sizes.bra = [size];
    return sizes;
  }

  function hasSizes(sizes) {
    return FAMILIES.some(function (f) {
      return sizes[f].length > 0;
    });
  }

  var dataCache = {};

  function fetchData(url) {
    if (!dataCache[url]) {
      dataCache[url] = fetch(url, { credentials: 'same-origin' })
        .then(function (response) {
          return response.ok ? response.text() : '';
        })
        .then(function (text) {
          var doc = new DOMParser().parseFromString(text, 'text/html');
          var node = doc.querySelector('[data-bg-recs-data]');
          return node ? JSON.parse(node.textContent).filter(Boolean) : [];
        })
        .catch(function () {
          return [];
        });
    }
    return dataCache[url];
  }

  function recsData(productId) {
    return fetchData(ROOT + 'recommendations/products?product_id=' + productId + '&limit=10&intent=related&section_id=bg-recs-data');
  }

  function searchQuery(ids) {
    return encodeURIComponent(
      ids
        .map(function (id) {
          return 'id:' + id;
        })
        .join(' OR ')
    );
  }

  function productUrl(handle, section) {
    return ROOT + 'products/' + encodeURIComponent(handle) + '?section_id=' + section;
  }

  function knownIds() {
    return readJSON(localStorage, IDS_KEY, {});
  }

  function rememberId(handle, id) {
    var ids = knownIds();
    delete ids[handle];
    ids[handle] = id;
    var keys = Object.keys(ids);
    if (keys.length > 40) {
      keys.slice(0, keys.length - 40).forEach(function (k) {
        delete ids[k];
      });
    }
    writeJSON(localStorage, IDS_KEY, ids);
  }

  // Impulse's recently viewed list: { handle: {...} }, oldest first. Returns handles, newest first.
  function historyHandles(currentHandle) {
    var recent = readJSON(localStorage, HISTORY_KEY, {});
    if (!recent || typeof recent !== 'object' || Array.isArray(recent)) return [];
    return Object.keys(recent)
      .reverse()
      .filter(function (handle) {
        return handle && handle !== currentHandle;
      });
  }

  // Product data for handles, in order. Known IDs go in one search request; the rest are fetched one by one.
  function productsByHandle(handles) {
    if (!handles.length) return Promise.resolve([]);
    var ids = knownIds();
    var known = handles.filter(function (h) {
      return ids[h];
    });
    var first = known.length
      ? fetchData(ROOT + 'search?type=product&q=' + searchQuery(known.map(function (h) {
          return ids[h];
        })) + '&section_id=bg-recs-data')
      : Promise.resolve([]);
    return first.then(function (list) {
      var byHandle = {};
      list.forEach(function (p) {
        byHandle[p.h] = p;
      });
      // 0 = looked up before and not recommendable (sold out or excluded), so don't fetch it on every page
      var missing = handles.filter(function (h) {
        return !byHandle[h] && ids[h] !== 0;
      });
      return Promise.all(
        missing.map(function (h) {
          return fetchData(productUrl(h, 'bg-recs-data'));
        })
      ).then(function (extra) {
        extra.forEach(function (one, index) {
          if (!one.length) rememberId(missing[index], 0);
          one.forEach(function (p) {
            byHandle[p.h] = p;
            rememberId(p.h, p.i);
          });
        });
        return handles
          .map(function (h) {
            return byHandle[h];
          })
          .filter(Boolean);
      });
    });
  }

  function fetchCards(url) {
    return fetch(url, { credentials: 'same-origin' })
      .then(function (response) {
        return response.ok ? response.text() : '';
      })
      .then(function (text) {
        var doc = new DOMParser().parseFromString(text, 'text/html');
        var templates = {};
        doc.querySelectorAll('template[data-bg-recs-card]').forEach(function (t) {
          templates[t.getAttribute('data-bg-recs-card')] = t;
        });
        return templates;
      })
      .catch(function () {
        return {};
      });
  }

  function sizeFilterValues(sizes) {
    var values = [];
    function add(v) {
      if (values.indexOf(v) < 0) values.push(v);
    }
    sizes.bra.forEach(function (size) {
      add(size);
      sistersOf(size, UK_SEQ).concat(sistersOf(size, NON_UK_SEQ)).forEach(add);
    });
    return values;
  }

  function collectionData(handle, sort, sizes, productType) {
    if (!handle) return Promise.resolve([]);
    var base = ROOT + 'collections/' + encodeURIComponent(handle) + '?sort_by=' + sort + '&section_id=bg-recs-data';
    if (productType) base += '&filter.p.product_type=' + encodeURIComponent(productType);
    var requests = [fetchData(base)];
    if (hasSizes(sizes)) {
      var filtered = base + sizeFilterValues(sizes).map(function (v) {
        return '&filter.v.option.size=' + encodeURIComponent(v);
      }).join('');
      requests.push(fetchData(filtered));
    }
    return Promise.all(requests).then(function (lists) {
      // The size-filtered list goes first, so best sellers in her size aren't cut off by the 50-product page
      return mergeLists(lists.reverse());
    });
  }

  function mergeLists(lists) {
    var seen = {};
    var out = [];
    lists.forEach(function (list) {
      list.forEach(function (p) {
        if (!seen[p.i]) {
          seen[p.i] = true;
          out.push(p);
        }
      });
    });
    return out;
  }

  function interleave(lists) {
    var out = [];
    var seen = {};
    var longest = Math.max.apply(null, [0].concat(lists.map(function (l) {
      return l.length;
    })));
    for (var i = 0; i < longest; i++) {
      lists.forEach(function (list) {
        var p = list[i];
        if (p && !seen[p.i]) {
          seen[p.i] = true;
          out.push(p);
        }
      });
    }
    return out;
  }

  function blend(ids, exclude) {
    return Promise.all(ids.slice(0, 4).map(recsData)).then(function (lists) {
      return interleave(lists).filter(function (p) {
        return exclude.indexOf(p.i) < 0;
      });
    });
  }

  function candidates(widget, sizes) {
    var d = widget.dataset;
    var currentId = parseInt(d.productId, 10) || 0;
    var handles = historyHandles(d.productHandle);
    var cartIds = (d.cartIds || '').split(',').map(function (id) {
      return parseInt(id, 10);
    }).filter(Boolean);
    var source = d.source;
    var primary;

    if (source === 'related') {
      primary = currentId ? recsData(currentId) : Promise.resolve([]);
    } else if (source === 'history') {
      primary = handles.length
        ? productsByHandle(handles.slice(0, 4)).then(function (viewed) {
            var ids = viewed.map(function (p) {
              return p.i;
            });
            return ids.length ? blend(ids, ids.concat([currentId])) : null;
          })
        : null;
    } else if (source === 'recent') {
      primary = handles.length ? productsByHandle(handles.slice(0, 14)) : null;
    } else if (source === 'collection_current') {
      primary = collectionData(d.currentCollection, 'best-selling', sizes);
    } else if (source === 'collection') {
      primary = collectionData(d.collection || 'all', d.sort || 'best-selling', sizes);
    } else if (source === 'cart') {
      primary = cartIds.length ? blend(cartIds, cartIds) : null;
    }

    primary = Promise.resolve(primary).then(function (list) {
      if (list) return list;
      if (d.fallback === 'all_best') return collectionData('all', 'best-selling', sizes);
      if (d.fallback === 'type_best' && d.productType) return collectionData('all', 'best-selling', sizes, d.productType);
      return [];
    });

    var topUp = d.topUp === 'true' ? collectionData('all', 'best-selling', sizes) : Promise.resolve([]);
    return Promise.all([primary, topUp]);
  }

  function minimum(widget) {
    // Recently viewed shows from one product, as Obviyo's "Still interested" did
    return widget.dataset.source === 'recent' ? 1 : MIN_PRODUCTS;
  }

  function choose(widget, lists, sizes, shown) {
    var d = widget.dataset;
    var count = parseInt(d.count, 10) || 12;
    var min = minimum(widget);
    var recent = d.source === 'recent';

    function pick(list) {
      var exact = [];
      var sister = [];
      list.forEach(function (p) {
        if (shown[p.i]) return;
        // Recently viewed shows what she looked at, whatever its sizes
        var match = recent ? 'any' : classify(p, sizes);
        if (match === 'exact' || match === 'any') exact.push(p);
        else if (match === 'sister') sister.push(p);
      });
      return exact.concat(sister);
    }

    var chosen = pick(lists[0]);
    if (chosen.length < MIN_PRODUCTS && d.topUp === 'true') chosen = mergeLists([chosen, pick(lists[1])]);
    chosen = chosen.slice(0, count);
    if (chosen.length < min) return [];
    chosen.forEach(function (p) {
      shown[p.i] = true;
    });
    return chosen;
  }

  function relevantSizes(chosen, sizes) {
    var families = {};
    chosen.forEach(function (p) {
      itemsOf(p.a).forEach(function (it) {
        families[it.f] = true;
      });
    });
    var out = [];
    FAMILIES.forEach(function (f) {
      if (families[f]) out = out.concat(sizes[f]);
    });
    return out;
  }

  function hide(widget) {
    var section = widget.closest('.shopify-section');
    if (section) section.style.display = 'none';
  }

  // Cards are rendered through storefront search, so their links carry search tracking (_pos, _sid, _ss).
  // Drop it so recommendation clicks don't count as search clicks, and add Shopify's pr_* tracking when known.
  function fixLinks(card, handle, trackedUrl) {
    var tracked = null;
    try {
      if (trackedUrl) tracked = new URL(trackedUrl, window.location.origin);
    } catch (e) {}
    card.querySelectorAll('a[href]').forEach(function (link) {
      var url;
      try {
        url = new URL(link.getAttribute('href'), window.location.origin);
      } catch (e) {
        return;
      }
      if (url.origin !== window.location.origin || !/\/products\/[^\/]+$/.test(url.pathname)) return;
      ['_pos', '_sid', '_ss'].forEach(function (key) {
        url.searchParams.delete(key);
      });
      if (tracked && url.pathname.split('/').pop() === handle) {
        tracked.searchParams.forEach(function (value, key) {
          if (key.indexOf('pr_') === 0) url.searchParams.set(key, value);
        });
      }
      link.setAttribute('href', url.pathname + url.search + url.hash);
    });
  }

  function updateArrows(widget) {
    var row = widget.querySelector('[data-bg-recs-row]');
    var prev = widget.querySelector('[data-bg-recs-prev]');
    var next = widget.querySelector('[data-bg-recs-next]');
    if (!row || !prev || !next) return;
    var overflow = row.scrollWidth - row.clientWidth > 4;
    prev.hidden = !overflow;
    next.hidden = !overflow;
    prev.disabled = row.scrollLeft <= 4;
    next.disabled = row.scrollLeft >= row.scrollWidth - row.clientWidth - 4;
  }

  function renderCards(widget, chosen, sizes) {
    var ids = chosen.map(function (p) {
      return p.i;
    });
    return fetchCards(ROOT + 'search?type=product&q=' + searchQuery(ids) + '&section_id=bg-recs-cards')
      .then(function (templates) {
        var missing = chosen.filter(function (p) {
          return !templates[p.i] && p.h;
        });
        return Promise.all(
          missing.map(function (p) {
            return fetchCards(productUrl(p.h, 'bg-recs-cards'));
          })
        ).then(function (extra) {
          extra.forEach(function (more) {
            Object.keys(more).forEach(function (id) {
              templates[id] = more[id];
            });
          });
          return templates;
        });
      })
      .then(function (templates) {
        var row = widget.querySelector('[data-bg-recs-row]');
        var added = 0;
        chosen.forEach(function (p) {
          var t = templates[p.i];
          if (!t) return;
          var card = document.importNode(t.content, true);
          fixLinks(card, p.h, p.u);
          // Impulse only fades card images in under .aos-animate; these cards arrive after AOS has run
          card.querySelectorAll('[data-aos]').forEach(function (el) {
            el.classList.add('aos-animate');
          });
          row.appendChild(card);
          added++;
        });
        if (added < minimum(widget)) {
          hide(widget);
          return;
        }

        var shownSizes = widget.dataset.source === 'recent' ? [] : relevantSizes(chosen, sizes);
        var note = widget.querySelector('[data-bg-recs-note]');
        if (note && shownSizes.length) {
          note.querySelector('[data-bg-recs-note-text]').textContent =
            'Showing ' + (shownSizes.length > 1 ? 'sizes ' : 'size ') + shownSizes.join(', ');
          note.hidden = false;
        } else if (note) {
          note.hidden = true;
        }

        var section = widget.closest('.shopify-section');
        if (section) section.style.display = 'block';
        updateArrows(widget);
        if (window.AOS && typeof window.AOS.refreshHard === 'function') window.AOS.refreshHard();
      })
      .catch(function () {
        hide(widget);
      });
  }

  function resetWidget(widget) {
    widget.querySelector('[data-bg-recs-row]').innerHTML = '';
  }

  function run(widgets) {
    var sizes = currentSizes();
    var shown = {};
    widgets.forEach(function (widget) {
      var d = widget.dataset;
      if (d.productId) shown[parseInt(d.productId, 10)] = true;
      (d.cartIds || '').split(',').forEach(function (id) {
        if (id) shown[parseInt(id, 10)] = true;
      });
    });

    var pending = widgets.map(function (widget) {
      return candidates(widget, sizes);
    });

    var chain = Promise.resolve();
    widgets.forEach(function (widget, index) {
      chain = chain.then(function () {
        return pending[index].then(function (lists) {
          var chosen = choose(widget, lists, sizes, shown);
          if (!chosen.length) {
            hide(widget);
            return;
          }
          renderCards(widget, chosen, sizes);
        });
      });
    });
  }

  function init() {
    var widgets = Array.prototype.slice.call(document.querySelectorAll('[data-bg-recs]'));
    if (!widgets.length) return;

    widgets.forEach(function (widget) {
      if (widget.dataset.productId && widget.dataset.productHandle) {
        rememberId(widget.dataset.productHandle, parseInt(widget.dataset.productId, 10));
      }
      var row = widget.querySelector('[data-bg-recs-row]');
      if (row) {
        row.addEventListener('scroll', function () {
          updateArrows(widget);
        }, { passive: true });
      }
    });

    document.addEventListener('click', function (event) {
      var target = event.target;
      var arrow = target && target.closest && target.closest('[data-bg-recs-prev], [data-bg-recs-next]');
      if (arrow) {
        var row = arrow.closest('[data-bg-recs]').querySelector('[data-bg-recs-row]');
        var step = row.clientWidth * 0.8 * (arrow.hasAttribute('data-bg-recs-prev') ? -1 : 1);
        row.scrollBy({ left: step, behavior: 'smooth' });
        return;
      }
      var button = target && target.closest && target.closest('[data-bg-recs-show-all]');
      if (!button) return;
      writeJSON(sessionStorage, ALL_SIZES_KEY, true);
      widgets.forEach(resetWidget);
      run(widgets);
    });

    window.addEventListener('resize', function () {
      widgets.forEach(updateArrows);
    });

    run(widgets);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
